import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import localeEn from '@angular/common/locales/en';
import localeMx from '@angular/common/locales/es-MX';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { routes } from './app.routing';
import { ExpirationMessageComponent } from './containers/expiration-message/expiration-message.component';
import { InterceptorErrorService } from './helper/InterceptorErrorService';
import { AuthService } from './services/core/auth.services';
import { CommonsService } from './services/commons/commons.services';
import { LoaderService } from './services/commons/loading.service';
import { Globals } from './shared/globals';
import { TranslateApiService } from './shared/translate-api';
import { NotAuthorizedComponent } from './views/core/not-authorized/not-authorized.component';

registerLocaleData(localeMx, 'es');
registerLocaleData(localeEn, 'en');

@NgModule({
  declarations: [AppComponent, NotAuthorizedComponent, ExpirationMessageComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatButtonModule,
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    ToastrModule.forRoot({
      autoDismiss: true,
      preventDuplicates: true
    }),
    TranslateModule.forRoot()
  ],
  providers: [
    ...provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json'
    }),
    AuthService,
    CommonsService,
    Globals,
    LoaderService,
    ToastrService,
    TranslateApiService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorErrorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
